import React from 'react'
import ReactInputMask from 'react-input-mask'

export const ValidateIp = (value) => {
  let ipv4_regex =
    /^(?:25[0-5]|2[0-4]\d|1\d\d|[1-9]\d|\d)(?:\.(?:25[0-5]|2[0-4]\d|1\d\d|[1-9]\d|\d)){3}$/gm
  if (!value) return 'Anda belum memasukan Ip'
  return ipv4_regex.test(value) ? undefined : 'Format Ip Salah'
}
export const ValidateIpNotRequired = (value) => {
  let ipv4_regex =
    /^(?:25[0-5]|2[0-4]\d|1\d\d|[1-9]\d|\d)(?:\.(?:25[0-5]|2[0-4]\d|1\d\d|[1-9]\d|\d)){3}$/gm

  if (!value) return undefined
  return ipv4_regex.test(value) ? undefined : 'Format Ip Salah'
}
export const MaxNotRequired = (max) => (value) => {
  if (!value) return undefined
  return value?.length < max ? 'Data yang anda masukan kurang dari ' + max : undefined
}

export const validateNIK = (value) => {
  if (!value) return 'Anda belum memasukan nik'
  // console.log(value)
  return value &&
    !/([0-9][0-9][0-9][0-9][0-9][0-9])-([0-9][0-9])(1[012]|0?[1-9])([0-9]{1,2})-([0-9][0-9][0-9][0-9])/i.test(
      value,
    )
    ? 'Format NIK Salah'
    : undefined
}
export const ValidateHttp = (value) => {
  if (!value) return 'Anda belum memasukan http'
  // console.log(value)
  return value && !/^(https?:\/\/)?((([a-zA-Z0-9-]+)\.)+[a-zA-Z]{2,}|(\d{1,3}\.){3}\d{1,3}):\d{1,5}(\/.*)?$/i.test(value)
    ? 'Format Url Salah'
    : undefined
}
export const validateNPWP = (value) => {
  if (!value) return 'Anda belum memasukan npwp'
  // console.log(value)
  return value && !/(\d{2})(\d{3})(\d{3})(\d{1})(\d{3})(\d{3})/i.test(value)
    ? 'Format npwp Salah'
    : undefined
}

/*eslint-disable */

class TextMaskNIK extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      // value: '',
      /* 332610-112907-0001 */
      mask: '999999-999999-9999',
    }
  }

  onChange = (event) => {
    var value = event.target.value
    var newState = {
      mask: '999999-999999-9999',
      // value: value
    }
    if (
      /([0-9][0-9][0-9][0-9][0-9][0-9])-([0-9][0-9])(1[012]|0?[1-9])([0-9]{1,2})-([0-9][0-9][0-9][0-9])/i.test(
        value,
      )
    ) {
      newState.mask = '999999-999999-9999'
    }
    this.setState(newState)
    this.props?.inputProps.onChange(value)
  }

  render() {
    const { inputProps, placeholder, size } = this.props

    return (
      <ReactInputMask
        value={inputProps?.value}
        name={inputProps.name}
        className={`form-control form-control-sm`}
        placeholder={placeholder}
        onChange={this.onChange}
        {...this.state}
      />
    )
  }
}

export default TextMaskNIK
